import { getBase64FromUrlAsync } from './fileUtils';
import { toBase64StringFormat } from './stringUtils';

const MINIO_URL = process.env.REACT_APP_MINIO_URL;

// export const toMinioBase64 = async (url: string): Promise<string> => {
//   return await getBase64FromUrl(`${MINIO_URL}${url}`);
// };
export const toMinioBase64 = async (url: string): Promise<string> =>
  getBase64FromUrlAsync(`${url}`);

export const handleImagePreviewOnUpdate = (image: string): string => {
  if (image.includes('http')) {
    let img = '';
    getBase64FromUrlAsync(image).then((res) => (img = res));
    return img;
  } else {
    return toBase64StringFormat(image);
  }
};
